import { render, staticRenderFns } from "./AuthorizationStatusTag.vue?vue&type=template&id=ef7c416c&"
import script from "./AuthorizationStatusTag.vue?vue&type=script&lang=js&"
export * from "./AuthorizationStatusTag.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationStatusTag.vue?vue&type=style&index=0&id=ef7c416c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports